// CalendarsPopupContents.jsx

import React from 'react';

// Utilities
import { getCalendarViewTypeIconKey } from 'utilities/ViewTypeIcons';

// CSS
import './CalendarsPopupContents.css';

// Components
import PopupOption from 'components/popup/option/PopupOption';

/**
 * CalendarsPopupContents
 * 
 * Renders the popup component for the calendar related views.
 * 
 * @param {object[]} options - Views options to display.
 * @param {string|null} selectedDateTypeId - Selected date type id.
 * @param {function} onSelectOption - Handler for selecting an option.
 *  
 *
 * @returns {ReactNode} - CalendarsPopupContents.
 */
const CalendarsPopupContents = React.memo(({
    options = [],
    selectedDateTypeId = null,
    onSelectOption,
}) => {

  // ----- RENDER ----- //

  return (
        <div className="calendars-popup-contents-container">

            {options.map((option) => {

                const iconKey = getCalendarViewTypeIconKey(option?.type);
                const isSelected = option.id === selectedDateTypeId;

                return (
                    <PopupOption
                      key={option.id}
                      iconKey={iconKey}
                      label={option.label}
                      selected={isSelected}
                      onClick={() => onSelectOption?.(option.id)}
                    />
                );
            })}

        </div>
    );

});

// Dev Tools
CalendarsPopupContents.displayName = 'CalendarsPopupContents';

export default CalendarsPopupContents;
